import { render, staticRenderFns } from "./PromotionConditionLogicalOperator.vue?vue&type=template&id=1031720d&"
import script from "./PromotionConditionLogicalOperator.vue?vue&type=script&lang=ts&"
export * from "./PromotionConditionLogicalOperator.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports